import React, { useEffect, useRef } from 'react';
import JsBarcode from 'jsbarcode';

const ContractBarcode = ({ value, onRendered }) => {
  const svgRef = useRef(null);

  useEffect(() => {
    if (!value || !svgRef.current) {
      onRendered?.();
      return;
    }

    try {
      JsBarcode(svgRef.current, value, {
        format: 'CODE128',
        width: 2.5,
        height: 75,
        displayValue: true,
        margin: 10,
      });
    } catch (error) {
      console.error('Failed to generate contract barcode', error);
    }

    onRendered?.();
  }, [value, onRendered]);

  if (!value) {
    return null;
  }

  return (
    <div className="contract-barcode">
      <svg ref={svgRef} role="img" aria-label={`Contract barcode ${value}`} />
    </div>
  );
};

export default ContractBarcode;
